import { BosatlasDto } from '../models/models';
import { get } from './HttpService';
import { populateBundleDates } from './BundleService';
import { HttpResponse } from '../redux/http/http.types';

export async function getBosatlas(): Promise<BosatlasDto> {
	const response: HttpResponse<BosatlasDto> = await get<BosatlasDto>(
		'bosAtlas',
		`MyBosatlas`
	);
	const bosatlas: BosatlasDto = response.data!;
	bosatlas.bundles = bosatlas.bundles?.map(populateBundleDates);
	return bosatlas;
}

export async function getBosatlasSearchSuggestions(
	searchValue: string
): Promise<string[]> {
	const response: HttpResponse<string[]> = await get<string[]>(
		'bosatlas',
		`mybosatlas/autocomplete?searchvalue=${searchValue}`
	);

	return response.data!;
}

export async function searchBosatlas(
	searchValue: string
): Promise<BosatlasDto> {
	const response: HttpResponse<BosatlasDto> = await get<BosatlasDto>(
		'bosatlas',
		`mybosatlas/search?searchvalue=${searchValue}`
	);
	const bosatlas: BosatlasDto = response.data!;

	bosatlas.bundles = bosatlas.bundles?.map(populateBundleDates);
	return bosatlas;
}
